import React, { Fragment } from "react";
import propTypes from "prop-types";
import {
  FiAlertTriangle,
  FiCheckCircle,
  FiClock,
  FiDownload,
  FiUpload,
} from "react-icons/fi";
import { IconButton } from "@mui/material";

import styles from "./styles";
import flex from "../../../../styles/flex";

import { PimTransaction } from "../../../../logic/api";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

function downloadObjectAsXml(exportStr: string, exportName: string) {
  try {
    const dataStr =
      "data:text/xml;charset=utf-8," +
      encodeURIComponent(exportStr);
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".xml");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  } catch (ex) {
    console.log(ex);
  }
}

const PimTranListItem: React.FunctionComponent<{
  pim: PimTransaction;
  selectedForRetry: boolean;
  onClick: () => void;
  onRetry: () => void;
}> = (props) => {
  const { toFormattedDateTimeString } = useDate();
  const { t } = useTranslation();

  return (
    <div
      style={{ ...styles.bookingListItem }}
      onClick={() => {
        if (props.onClick != null) {
          props.onClick();
        }
      }}
    >
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          width: 120,
          left: -67,
          bottom: 0,
          height: 15,
          top: 30,
          fontSize: 10,
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: "white",
          transform: "rotate(270deg)",
        }}
      >
        <span>{t("booking.labels.ingestion")}</span>
      </div>
      <div style={styles.bookingListItemFlex}>
        <ListViewItemCard
          icon={
            props.pim.isError == true ? (
              <FiAlertTriangle color="red" style={styles.icon} />
            ) : (
              <FiCheckCircle color="green" style={styles.icon} />
            )
          }
          wrap={false}
          text={
            props.pim.fileType + " - " + (props.pim.retryCount == 0
              ? toFormattedDateTimeString(new Date(props.pim.createDate))
              : t("lists.retryCount", { date: toFormattedDateTimeString(new Date(props.pim.createDate)), count: props.pim.retryCount }))
          }
          subText={`${props.pim.message == null ? "" : props.pim.message
            } ${props.pim.bookingId == null
              ? ""
              : t("lists.bookingID", { id: props.pim.bookingId })
            }`}
        />

        <ListViewItemCard
          icon={null}
          text={
            props.pim.clientCode == null
              ? t("lists.unknown")
              : props.pim.clientCode.toString()
          }
          subText={props.pim.siteCode == null
            ? t("lists.unknown")
            : props.pim.siteCode.toString()}
        />

        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
          {props.pim.content != null && (
            <Fragment>
              <IconButton
                onClick={() => {
                  downloadObjectAsXml(
                    props.pim.content,
                    props.pim.fileName
                  );
                }}
              >
                <FiDownload />
              </IconButton>
              <div>
                <small>{t("general.download")}</small>
              </div>
            </Fragment>
          )}
        </div>
        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>


          <Fragment>
            {props.selectedForRetry == false && (props.pim.content != null && props.pim.content != "") && (
              <Fragment>
                <IconButton
                  onClick={() => {
                    props.onRetry();
                  }}
                >
                  <FiUpload />
                </IconButton>
                <div>
                  <small>{t("general.retry")}</small>
                </div>
              </Fragment>
            )}
            {props.selectedForRetry == true && (props.pim.content != null && props.pim.content != "") && (
              <Fragment>
                <IconButton
                  onClick={() => {
                    props.onRetry();
                  }}
                >
                  <FiClock color="orange" />
                </IconButton>
                <div>
                  <small>{t("general.queued")}</small>
                </div>
              </Fragment>
            )}
          </Fragment>

        </div>
      </div>
    </div>
  );
};

PimTranListItem.propTypes = {
  pim: propTypes.any.isRequired,
  selectedForRetry: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired,
  onRetry: propTypes.func.isRequired,
};

export default PimTranListItem;
